<header class="app-header">
  <div class="header-container">
    <!-- Hamburger Menu Button (Mobile/Tablet only) -->
    @if (responsiveService.isMobileOrTablet()) {
      <button 
        class="hamburger-button"
        (click)="toggleMobileMenu()"
        [attr.aria-expanded]="showMobileMenu()"
        aria-label="Toggle navigation menu">
        @if (!showMobileMenu()) {
          <!-- Hamburger Icon -->
          <svg class="menu-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        } @else {
          <!-- Close Icon -->
          <svg class="menu-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        }
      </button>
    }

    <!-- Logo and Brand -->
    <div class="brand">
      <a routerLink="/dashboard" class="logo-link" aria-label="QA Agent home">
        <img class="logo" src="img/westmarq-white.svg" alt="Westmarq" width="116" height="34">
        <span class="brand-divider" aria-hidden="true"></span>
        <span class="brand-name">QA Agent</span>
      </a>
    </div>

    <!-- Desktop Navigation Menu -->
    @if (responsiveService.isDesktop()) {
      <nav class="nav-menu">
        <a 
          routerLink="/dashboard" 
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="nav-link">
          <svg class="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          Dashboard
        </a>

        <a 
          routerLink="/upload" 
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="nav-link">
          <svg class="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
          </svg>
          Upload
        </a>

        <a 
          routerLink="/rules" 
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="nav-link">
          <svg class="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
          </svg>
          Rules
        </a>

        <a 
          routerLink="/profiles" 
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="nav-link">
          <svg class="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
          Profiles
        </a>

        <a 
          routerLink="/history" 
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="nav-link">
          <svg class="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          History
        </a>
      </nav>
    }

    <!-- Help Button -->
    @if (responsiveService.isDesktop()) {
      <button 
        routerLink="/help"
        class="help-button"
        matTooltip="Get help and documentation"
        aria-label="Get help and documentation">
        <svg class="help-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </button>
    }

    <!-- User Menu -->
    <div class="user-section" (clickOutside)="closeUserMenu()">
      <button 
        class="user-button" 
        (click)="toggleUserMenu()"
        [attr.aria-expanded]="showUserMenu()"
        aria-label="User menu">
        <div class="user-avatar">{{ getUserInitials() }}</div>
        @if (responsiveService.isDesktop()) {
          <div class="user-info">
            <span class="user-name">{{ user()?.name || 'User' }}</span>
            <span class="user-email">{{ user()?.email || '' }}</span>
          </div>
          <svg class="chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        }
      </button>

      @if (showUserMenu()) {
        <div class="user-dropdown">
          <div class="dropdown-section">
            <div class="user-details">
              <div class="detail-label">Signed in as</div>
              <div class="detail-value">{{ user()?.email }}</div>
            </div>
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-section">
            <button class="dropdown-item" (click)="logout()">
              <svg class="item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              Sign out
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</header>

<!-- Mobile Navigation Drawer -->
@if (responsiveService.isMobileOrTablet() && showMobileMenu()) {
  <div class="mobile-nav-overlay" (click)="closeMobileMenu()"></div>
  <nav class="mobile-nav" (clickOutside)="closeMobileMenu()">
    <div class="mobile-nav-header">
      <span class="mobile-nav-title">Navigation</span>
      <button class="close-button" (click)="closeMobileMenu()" aria-label="Close menu">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="mobile-nav-content">
      <a 
        routerLink="/dashboard" 
        routerLinkActive="active"
          ariaCurrentWhenActive="page"
        (click)="closeMobileMenu()"
        class="mobile-nav-link">
        <svg class="mobile-nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
        Dashboard
      </a>

      <a 
        routerLink="/upload" 
        routerLinkActive="active"
          ariaCurrentWhenActive="page"
        (click)="closeMobileMenu()"
        class="mobile-nav-link">
        <svg class="mobile-nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
        </svg>
        Upload
      </a>

      <a 
        routerLink="/rules" 
        routerLinkActive="active"
          ariaCurrentWhenActive="page"
        (click)="closeMobileMenu()"
        class="mobile-nav-link">
        <svg class="mobile-nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
        </svg>
        Rules
      </a>

      <a 
        routerLink="/profiles" 
        routerLinkActive="active"
          ariaCurrentWhenActive="page"
        (click)="closeMobileMenu()"
        class="mobile-nav-link">
        <svg class="mobile-nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
        Profiles
      </a>

      <a 
        routerLink="/history" 
        routerLinkActive="active"
          ariaCurrentWhenActive="page"
        (click)="closeMobileMenu()"
        class="mobile-nav-link">
        <svg class="mobile-nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        History
      </a>

      <div class="mobile-nav-divider"></div>

      <a 
        routerLink="/help" 
        routerLinkActive="active"
          ariaCurrentWhenActive="page"
        (click)="closeMobileMenu()"
        class="mobile-nav-link">
        <svg class="mobile-nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Help
      </a>
    </div>
  </nav>
}
